import * as z from "../../../vendor/zod/src/index";
const BalanceEntry = z.object({
    date: z.string(),
    amount: z.string(),
});
export default z.object({
    balances: z.array(BalanceEntry),
});
